<template>
  <div>
    <p class='mb-5'>{{ 'uwv-decision.new-header-text' | translate }}</p>

    <report-of-sickness-card :employee="this.employee" :reportOfSickness="reportOfSickness" class='mt-5 mb-4'/>
    <uwv-decision-form :isEditing="false" />

    <div style='float: right' class='mt-4'>
      <Button primary class="mr-3"
        @click="this.handlePreviousClick">
        {{ 'buttons.cancel' | translate }}
      </Button>
      <Button secondary
        @click="this.handleContinueClick"
        :disabled="!isValid" :hoverErrors="continueHoverErrors">
        {{ 'buttons.next-step' | translate }}
      </Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import UwvDecisionForm from '@/views/components/uwv-decisions/UwvDecisionForm.vue';
import NewUwvDecision from '@/views/constants/uwv-decision-new';

import ReportOfSicknessCard from '@/views/components/reports-of-sickness/ReportOfSicknessCard.vue';

export default {
  name: 'NewUwvDecisionForm',
  components: {
    Button,
    ReportOfSicknessCard,
    UwvDecisionForm
  },
  props: {
    employee: Object,
    reportOfSickness: Object
  },
  computed: {
    ...mapGetters({
      newUwvDecision: 'newUwvDecision',
      requiredFields: 'newUwvDecisionRequiredFields',
      validations: 'newUwvDecisionValidations'
    }),

    isValid () {
      return this.requiredFields.isValid() && this.validations.isValid();
    },

    continueHoverErrors () {
      if (!this.requiredFields.isValid()) return [this.$t('errors.provide-all-required-fields')];
      return [];
    }
  },
  methods: {
    dispatchChange (attribute, value) {
      this.$store.dispatch(NewUwvDecision.Actions.Form.CHANGE, { attribute: attribute, value: value });
    },
    handleContinueClick () {
      this.$store.dispatch(NewUwvDecision.Actions.Navigate.DO, NewUwvDecision.Views.Confirmation);
    },
    handlePreviousClick () {
      this.$store.dispatch(NewUwvDecision.Actions.Cancel.DO);
    }
  }
};
</script>
